import { useSelector } from "react-redux";
import type { RootState } from "state/rootReducer";

export const useIsWebsocketConnected = () => {
  return useSelector((state: RootState) => state.websocket.isConnected);
};
